(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  if (window.TFAnalytics && window.TFAnalytics.initialised) {
    return;
  }

  var DEBUG_QUERY_PARAM = 'tf_analytics_debug';
  var PENDING_ADD_TO_CART_STORAGE_KEY = 'tfAnalytics.pendingAddToCart';
  var CART_LINE_CHANGE_SUCCESS_EVENT = 'tf:cart-line-change-success';
  var COLLECTION_RESULTS_REPLACED_EVENT = 'tf:collection-results-replaced';
  var MARKETING_SIGNUP_EVENT_NAME = 'tf_marketing_signup_provider_success';
  var MARKETING_SIGNUP_EVENT_CONTRACT_VERSION = 'v1';
  var MARKETING_SIGNUP_SURFACE_BY_FORM_ID = {
    RzCNYn: 'updates_page',
    UAHjPS: 'footer'
  };

  function setDebug(enabled) {
    TFAnalytics.debug = Boolean(enabled);
    return TFAnalytics.debug;
  }

  function log() {
    if (!TFAnalytics.debug || !window.console || typeof window.console.log !== 'function') {
      return;
    }

    var args = Array.prototype.slice.call(arguments);
    args.unshift('[TFAnalytics]');
    window.console.log.apply(window.console, args);
  }

  function safeNumber(value) {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : null;
    }

    if (typeof value === 'string') {
      var trimmedValue = value.trim();

      if (trimmedValue === '') {
        return null;
      }

      value = trimmedValue.replace(/[^\d.-]/g, '');
    }

    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function getDataAttr(element, attributeName) {
    if (!element || !attributeName || typeof element.getAttribute !== 'function') {
      return null;
    }

    return element.getAttribute('data-' + attributeName) || null;
  }

  function getSourceComponent(element) {
    return getDataAttr(element, 'analytics-source-component');
  }

  function push(payload) {
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
      return false;
    }

    window.dataLayer.push(payload);
    log('push', payload);
    return true;
  }

  function clearEcommerce() {
    return push({ ecommerce: null });
  }

  function runOnce(key, callback) {
    if (!key || typeof callback !== 'function') {
      return false;
    }

    if (TFAnalytics.guards[key]) {
      return false;
    }

    TFAnalytics.guards[key] = true;
    callback();
    return true;
  }

  function resetGuard(key) {
    if (!key) {
      return false;
    }

    delete TFAnalytics.guards[key];
    return true;
  }

  function getPageContext() {
    var documentElement = document.documentElement;
    var location = window.location;
    var template = documentElement ? getDataAttr(documentElement, 'template') : null;

    return {
      path: location.pathname,
      url: location.href,
      title: document.title,
      template: template,
      bodyClass: document.body ? document.body.className || '' : ''
    };
  }

  function getCustomerIdentityContextElement() {
    return document.querySelector('[data-analytics-customer-identity]');
  }

  function getCustomerIdentityContext() {
    var contextElement = getCustomerIdentityContextElement();
    var contextPayload;

    if (!contextElement) {
      return null;
    }

    try {
      contextPayload = JSON.parse(contextElement.textContent || '');
    } catch (error) {
      return null;
    }

    if (!contextPayload || typeof contextPayload !== 'object' || Array.isArray(contextPayload)) {
      return null;
    }

    return contextPayload;
  }

  function buildItemFromProductCard(productCard) {
    var itemId = getDataAttr(productCard, 'analytics-variant-id') || getDataAttr(productCard, 'analytics-product-id');
    var itemName = getDataAttr(productCard, 'analytics-product-title');
    var item = {};
    var price = safeNumber(getDataAttr(productCard, 'analytics-price'));
    var index = safeNumber(getDataAttr(productCard, 'analytics-index'));
    var scriptureReferenceCount = safeNumber(getDataAttr(productCard, 'analytics-scripture-reference-count'));
    var skuCount = safeNumber(getDataAttr(productCard, 'analytics-sku-count'));

    if (!itemId && !itemName) {
      return null;
    }

    if (itemId) {
      item.item_id = itemId;
    }

    if (itemName) {
      item.item_name = itemName;
    }

    if (getDataAttr(productCard, 'analytics-item-brand')) {
      item.item_brand = getDataAttr(productCard, 'analytics-item-brand');
    }

    if (getDataAttr(productCard, 'analytics-product-type')) {
      item.product_type = getDataAttr(productCard, 'analytics-product-type');
    }

    if (getDataAttr(productCard, 'analytics-included-jewelry')) {
      item.included_jewelry = getDataAttr(productCard, 'analytics-included-jewelry');
    }

    if (price !== null) {
      item.price = price;
    }

    if (index !== null) {
      item.index = index;
    }

    if (getDataAttr(productCard, 'analytics-color-or-design')) {
      item.color_or_design = getDataAttr(productCard, 'analytics-color-or-design');
    }

    if (getDataAttr(productCard, 'analytics-scripture-reference')) {
      item.scripture_reference = getDataAttr(productCard, 'analytics-scripture-reference');
    }

    if (getDataAttr(productCard, 'analytics-scripture-reference-2')) {
      item.scripture_reference_2 = getDataAttr(productCard, 'analytics-scripture-reference-2');
    }

    if (getDataAttr(productCard, 'analytics-scripture-reference-3')) {
      item.scripture_reference_3 = getDataAttr(productCard, 'analytics-scripture-reference-3');
    }

    if (getDataAttr(productCard, 'analytics-scripture-reference-4')) {
      item.scripture_reference_4 = getDataAttr(productCard, 'analytics-scripture-reference-4');
    }

    if (getDataAttr(productCard, 'analytics-scripture-reference-5')) {
      item.scripture_reference_5 = getDataAttr(productCard, 'analytics-scripture-reference-5');
    }

    if (getDataAttr(productCard, 'analytics-scripture-reference-6')) {
      item.scripture_reference_6 = getDataAttr(productCard, 'analytics-scripture-reference-6');
    }

    if (scriptureReferenceCount !== null) {
      item.scripture_reference_count = scriptureReferenceCount;
    }

    if (getDataAttr(productCard, 'analytics-biblical-theme')) {
      item.biblical_theme = getDataAttr(productCard, 'analytics-biblical-theme');
    }

    if (getDataAttr(productCard, 'analytics-occasion')) {
      item.occasion = getDataAttr(productCard, 'analytics-occasion');
    }

    if (getDataAttr(productCard, 'analytics-chain-style')) {
      item.chain_style = getDataAttr(productCard, 'analytics-chain-style');
    }

    if (getDataAttr(productCard, 'analytics-is-set')) {
      item.is_set = getDataAttr(productCard, 'analytics-is-set');
    }

    if (getDataAttr(productCard, 'analytics-price-bracket')) {
      item.price_bracket = getDataAttr(productCard, 'analytics-price-bracket');
    }

    if (skuCount !== null) {
      item.sku_count = skuCount;
    }

    if (getDataAttr(productCard, 'analytics-collection-handle')) {
      item.collection_handle = getDataAttr(productCard, 'analytics-collection-handle');
    }

    if (getDataAttr(productCard, 'analytics-collection-type')) {
      item.collection_type = getDataAttr(productCard, 'analytics-collection-type');
    }

    if (getDataAttr(productCard, 'analytics-source-component')) {
      item.source_component = getDataAttr(productCard, 'analytics-source-component');
    }

    return item;
  }

  function getCollectionGridProductCards() {
    return Array.prototype.slice.call(document.querySelectorAll('.shopify-section--main-collection .collection__main > product-list.product-list > product-card.product-card[data-analytics-source-component="collection_grid"]'));
  }

  function getHomepageRailCarousels() {
    return Array.prototype.slice.call(document.querySelectorAll('.shopify-section--featured-collections featured-collections-carousel[data-analytics-homepage-rails="true"]'));
  }

  function getHomepageRailSelectedPane(carouselElement) {
    if (!carouselElement) {
      return null;
    }

    return carouselElement.querySelector('.featured-collections-carousel__item.is-selected[data-analytics-homepage-rail="true"]');
  }

  function getHomepageRailProductCards(railPane) {
    if (!railPane) {
      return [];
    }

    return Array.prototype.slice.call(railPane.querySelectorAll('product-card.product-card[data-analytics-source-component="homepage_featured_collection_rail"]'));
  }

  function getComplementaryProductsElements() {
    return Array.prototype.slice.call(document.querySelectorAll('product-recommendations[data-analytics-complementary-products="true"][intent="complementary"]'));
  }

  function getComplementaryProductsObserverTarget() {
    return document.querySelector('.shopify-section--main-product product-rerender') ||
      document.querySelector('.shopify-section--main-product') ||
      null;
  }

  function getComplementaryProductsProductCards(complementaryProductsElement) {
    var isMobileViewport;
    var mobileProductCards;
    var desktopHorizontalCards;
    var allHorizontalCards;

    if (!complementaryProductsElement) {
      return [];
    }

    isMobileViewport = window.matchMedia && window.matchMedia('(max-width: 699px)').matches;
    mobileProductCards = Array.prototype.slice.call(complementaryProductsElement.querySelectorAll(
      '[class~="sm:hidden"] product-card.product-card[data-analytics-source-component="pdp_complementary_products"]'
    ));
    desktopHorizontalCards = Array.prototype.slice.call(complementaryProductsElement.querySelectorAll(
      '[class~="sm-max:hidden"] .horizontal-product-card[data-analytics-source-component="pdp_complementary_products"]'
    ));

    if (isMobileViewport && mobileProductCards.length) {
      return mobileProductCards;
    }

    if (!isMobileViewport && desktopHorizontalCards.length) {
      return desktopHorizontalCards;
    }

    allHorizontalCards = Array.prototype.slice.call(complementaryProductsElement.querySelectorAll(
      '.horizontal-product-card[data-analytics-source-component="pdp_complementary_products"]'
    ));

    if (allHorizontalCards.length) {
      return allHorizontalCards;
    }

    return mobileProductCards;
  }

  function getCollectionGridElement() {
    return document.querySelector('.shopify-section--main-collection .collection__main > product-list.product-list[data-analytics-collection-grid="true"]');
  }

  function getMarketingSignupSurface(formId) {
    return typeof formId === 'string' && Object.prototype.hasOwnProperty.call(MARKETING_SIGNUP_SURFACE_BY_FORM_ID, formId)
      ? MARKETING_SIGNUP_SURFACE_BY_FORM_ID[formId]
      : null;
  }

  function getMarketingSignupConsentState() {
    var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;

    if (!customerPrivacy || typeof customerPrivacy.analyticsProcessingAllowed !== 'function') {
      return 'consent_api_unavailable';
    }

    try {
      return customerPrivacy.analyticsProcessingAllowed() ? 'analytics_allowed' : 'analytics_denied';
    } catch (error) {
      return 'consent_api_unavailable';
    }
  }

  function refreshMarketingSignupConsentState() {
    var consentState = getMarketingSignupConsentState();

    if (window.TFAnalytics) {
      window.TFAnalytics.marketingSignupConsentState = consentState;
    }

    return consentState;
  }

  function initMarketingSignupConsent() {
    runOnce('marketing-signup-consent', function () {
      var shopify = window.Shopify;

      document.addEventListener('visitorConsentCollected', refreshMarketingSignupConsentState);
      refreshMarketingSignupConsentState();

      if (shopify && typeof shopify.loadFeatures === 'function' && (!shopify.customerPrivacy || typeof shopify.customerPrivacy.analyticsProcessingAllowed !== 'function')) {
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
          refreshMarketingSignupConsentState();
        });
      }
    });
  }

  function trackMarketingSignupProviderSuccess(formId) {
    var surfaceKey = getMarketingSignupSurface(formId);

    if (!surfaceKey || refreshMarketingSignupConsentState() !== 'analytics_allowed') {
      return false;
    }

    if (TFAnalytics.marketingSignupSeenForms[formId]) {
      return false;
    }

    if (!push({
      event: MARKETING_SIGNUP_EVENT_NAME,
      event_contract_version: MARKETING_SIGNUP_EVENT_CONTRACT_VERSION,
      surface_key: surfaceKey,
      interaction_state: 'provider_success_observed'
    })) {
      return false;
    }

    TFAnalytics.marketingSignupSeenForms[formId] = true;
    return true;
  }

  function initMarketingSignupProviderSuccess() {
    initMarketingSignupConsent();

    runOnce('marketing-signup-provider-success', function () {
      window.addEventListener('klaviyoForms', function (event) {
        var detail = event && event.detail;

        if (!detail || detail.type !== 'submit') {
          return;
        }

        trackMarketingSignupProviderSuccess(detail.formId);
      });
    });
  }

  function getNormalizedCollectionListParams(urlValue) {
    var sourceUrl;
    var sortOption = '';
    var pageNumber = 1;
    var filterTokens = [];

    try {
      sourceUrl = urlValue ? new URL(urlValue, window.location.origin) : new URL(window.location.href);
    } catch (error) {
      sourceUrl = new URL(window.location.href);
    }

    sourceUrl.searchParams.forEach(function (value, key) {
      var normalizedValue = typeof value === 'string' ? value.trim() : '';

      if (!normalizedValue || key === 'section_id') {
        return;
      }

      if (key === 'sort_by') {
        sortOption = normalizedValue;
        return;
      }

      if (key === 'page') {
        pageNumber = safeNumber(normalizedValue) || 1;
        return;
      }

      filterTokens.push(key + '=' + normalizedValue);
    });

    filterTokens.sort();

    return {
      sortOption: sortOption,
      pageNumber: pageNumber,
      appliedFilters: filterTokens.join(','),
      filterTokens: filterTokens
    };
  }

  function getCollectionGridMode(gridElement) {
    if (!gridElement) {
      return null;
    }

    if (window.matchMedia && window.matchMedia('(max-width: 699px)').matches) {
      return gridElement.getAttribute('collection-mobile-layout') || null;
    }

    return gridElement.getAttribute('collection-desktop-layout') || gridElement.getAttribute('collection-mobile-layout') || null;
  }

  function buildCollectionGridListState(urlValue) {
    var gridElement = getCollectionGridElement();
    var productCards = getCollectionGridProductCards();
    var items = productCards
      .map(buildItemFromProductCard)
      .filter(function (item) {
        return item && (item.item_id || item.item_name);
      });
    var firstCard = productCards[0];
    var normalizedParams;
    var sortOption;
    var pageNumber;
    var collectionHandle;
    var appliedFilters;
    var orderedProductIds;
    var listStateKey;

    if (!gridElement || !firstCard || !items.length) {
      return null;
    }

    normalizedParams = getNormalizedCollectionListParams(urlValue);
    sortOption = getDataAttr(gridElement, 'analytics-sort-option') || normalizedParams.sortOption || '';
    pageNumber = safeNumber(getDataAttr(gridElement, 'analytics-page-number'));
    pageNumber = pageNumber === null ? normalizedParams.pageNumber : pageNumber;
    collectionHandle = getDataAttr(gridElement, 'analytics-collection-handle') || getDataAttr(firstCard, 'analytics-collection-handle') || '';
    appliedFilters = normalizedParams.appliedFilters;
    orderedProductIds = productCards
      .map(function (productCard) {
        return getDataAttr(productCard, 'analytics-product-id') || getDataAttr(productCard, 'analytics-variant-id') || '';
      })
      .filter(function (productId) {
        return !!productId;
      });
    listStateKey = [
      'collection:' + (collectionHandle || ''),
      'sort:' + sortOption,
      'filters:' + (appliedFilters || 'none'),
      'page:' + String(pageNumber || 1),
      'products:' + orderedProductIds.join(',')
    ].join('|');

    return {
      gridElement: gridElement,
      productCards: productCards,
      items: items,
      firstCard: firstCard,
      itemListName: getDataAttr(firstCard, 'analytics-item-list-name'),
      itemListId: getDataAttr(firstCard, 'analytics-item-list-id'),
      sourceComponent: getSourceComponent(gridElement) || getSourceComponent(firstCard),
      collectionHandle: collectionHandle,
      collectionType: getDataAttr(gridElement, 'analytics-collection-type') || getDataAttr(firstCard, 'analytics-collection-type') || '',
      sortOption: sortOption,
      pageNumber: pageNumber || 1,
      resultsCount: safeNumber(getDataAttr(gridElement, 'analytics-results-count')),
      renderedItemCount: items.length,
      appliedFilterCount: safeNumber(getDataAttr(gridElement, 'analytics-applied-filter-count')),
      appliedFilters: appliedFilters,
      filterTokens: normalizedParams.filterTokens,
      gridMode: getCollectionGridMode(gridElement),
      listStateKey: listStateKey
    };
  }

  function getCollectionGridListStateChangeType(nextState, previousState, fallbackChangeType) {
    var changedParts = [];

    if (fallbackChangeType === 'initial_load') {
      return 'initial_load';
    }

    if (!previousState) {
      return fallbackChangeType || 'results_replaced_unknown';
    }

    if (previousState.sortOption !== nextState.sortOption) {
      changedParts.push('sort_changed');
    }

    if (previousState.appliedFilters !== nextState.appliedFilters) {
      changedParts.push('filters_changed');
    }

    if (String(previousState.pageNumber) !== String(nextState.pageNumber)) {
      changedParts.push('pagination_changed');
    }

    if (changedParts.length) {
      return changedParts.join('+');
    }

    return fallbackChangeType || 'results_replaced_unknown';
  }

  function isHomepageRailPaneVisible(railPane) {
    var rect;
    var viewportHeight;
    var visibleHeight;
    var visibleRatio;

    if (!railPane || typeof railPane.getBoundingClientRect !== 'function') {
      return false;
    }

    rect = railPane.getBoundingClientRect();

    if (rect.width <= 0 || rect.height <= 0) {
      return false;
    }

    viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);

    if (visibleHeight <= 0) {
      return false;
    }

    visibleRatio = visibleHeight / rect.height;

    return visibleRatio >= 0.5;
  }

  function buildHomepageRailListState(railPane) {
    var productCards = getHomepageRailProductCards(railPane);
    var items = productCards
      .map(buildItemFromProductCard)
      .filter(function (item) {
        return item && (item.item_id || item.item_name);
      });
    var firstCard = productCards[0];
    var sectionId;
    var blockId;
    var itemListId;
    var orderedProductIds;
    var listStateKey;

    if (!railPane || !firstCard || !items.length) {
      return null;
    }

    sectionId = getDataAttr(railPane, 'analytics-homepage-section-id') || '';
    blockId = getDataAttr(railPane, 'analytics-homepage-block-id') || '';
    itemListId = getDataAttr(railPane, 'analytics-item-list-id') || getDataAttr(firstCard, 'analytics-item-list-id') || '';
    orderedProductIds = productCards
      .map(function (productCard) {
        return getDataAttr(productCard, 'analytics-product-id') || getDataAttr(productCard, 'analytics-variant-id') || '';
      })
      .filter(function (productId) {
        return !!productId;
      });
    listStateKey = [
      'homepage_rail',
      'section:' + sectionId,
      'block:' + blockId,
      'list:' + itemListId,
      'products:' + orderedProductIds.join(',')
    ].join('|');

    return {
      railPane: railPane,
      productCards: productCards,
      items: items,
      firstCard: firstCard,
      sectionId: sectionId,
      blockId: blockId,
      itemListName: getDataAttr(railPane, 'analytics-item-list-name') || getDataAttr(firstCard, 'analytics-item-list-name'),
      itemListId: itemListId,
      sourceComponent: getDataAttr(railPane, 'analytics-source-component') || getDataAttr(firstCard, 'analytics-source-component'),
      collectionHandle: getDataAttr(railPane, 'analytics-collection-handle') || getDataAttr(firstCard, 'analytics-collection-handle') || '',
      collectionType: getDataAttr(railPane, 'analytics-collection-type') || getDataAttr(firstCard, 'analytics-collection-type') || '',
      renderedItemCount: items.length,
      listStateKey: listStateKey
    };
  }

  function buildComplementaryProductsListState(complementaryProductsElement) {
    var productCards = getComplementaryProductsProductCards(complementaryProductsElement);
    var items = productCards
      .map(buildItemFromProductCard)
      .filter(function (item) {
        return item && (item.item_id || item.item_name);
      });
    var firstCard = productCards[0];
    var sectionId;
    var blockId;
    var itemListId;
    var orderedProductIds;
    var listStateKey;

    if (!complementaryProductsElement || !firstCard || !items.length) {
      return null;
    }

    sectionId = getDataAttr(complementaryProductsElement, 'analytics-complementary-products-section-id') || '';
    blockId = getDataAttr(complementaryProductsElement, 'analytics-complementary-products-block-id') || '';
    itemListId = getDataAttr(complementaryProductsElement, 'analytics-item-list-id') || getDataAttr(firstCard, 'analytics-item-list-id') || '';
    orderedProductIds = productCards
      .map(function (productCard) {
        return getDataAttr(productCard, 'analytics-product-id') || getDataAttr(productCard, 'analytics-variant-id') || '';
      })
      .filter(function (productId) {
        return !!productId;
      });
    listStateKey = [
      'pdp_complementary_products',
      'section:' + sectionId,
      'block:' + blockId,
      'list:' + itemListId,
      'products:' + orderedProductIds.join(',')
    ].join('|');

    return {
      complementaryProductsElement: complementaryProductsElement,
      productCards: productCards,
      items: items,
      firstCard: firstCard,
      sectionId: sectionId,
      blockId: blockId,
      itemListName: getDataAttr(complementaryProductsElement, 'analytics-item-list-name') || getDataAttr(firstCard, 'analytics-item-list-name'),
      itemListId: itemListId,
      sourceComponent: getDataAttr(complementaryProductsElement, 'analytics-source-component') || getDataAttr(firstCard, 'analytics-source-component'),
      renderedItemCount: items.length,
      listStateKey: listStateKey
    };
  }

  function getPdpAnalyticsElement() {
    var pageContext = getPageContext();

    if (pageContext.template !== 'product') {
      return null;
    }

    return document.querySelector('.shopify-section--main-product [data-analytics-pdp="true"]');
  }

  function buildItemFromPdpAnalyticsElement(pdpElement) {
    var itemId = getDataAttr(pdpElement, 'analytics-variant-id') || getDataAttr(pdpElement, 'analytics-product-id');
    var itemName = getDataAttr(pdpElement, 'analytics-product-title');
    var item = {};
    var price = safeNumber(getDataAttr(pdpElement, 'analytics-price'));
    var scriptureReferenceCount = safeNumber(getDataAttr(pdpElement, 'analytics-scripture-reference-count'));
    var skuCount = safeNumber(getDataAttr(pdpElement, 'analytics-sku-count'));

    if (!itemId && !itemName) {
      return null;
    }

    if (itemId) {
      item.item_id = itemId;
    }

    if (itemName) {
      item.item_name = itemName;
    }

    if (getDataAttr(pdpElement, 'analytics-item-brand')) {
      item.item_brand = getDataAttr(pdpElement, 'analytics-item-brand');
    }

    if (price !== null) {
      item.price = price;
    }

    if (getDataAttr(pdpElement, 'analytics-product-type')) {
      item.product_type = getDataAttr(pdpElement, 'analytics-product-type');
    }

    if (getDataAttr(pdpElement, 'analytics-included-jewelry')) {
      item.included_jewelry = getDataAttr(pdpElement, 'analytics-included-jewelry');
    }

    if (getDataAttr(pdpElement, 'analytics-color-or-design')) {
      item.color_or_design = getDataAttr(pdpElement, 'analytics-color-or-design');
    }

    if (getDataAttr(pdpElement, 'analytics-scripture-reference')) {
      item.scripture_reference = getDataAttr(pdpElement, 'analytics-scripture-reference');
    }

    if (getDataAttr(pdpElement, 'analytics-scripture-reference-2')) {
      item.scripture_reference_2 = getDataAttr(pdpElement, 'analytics-scripture-reference-2');
    }

    if (getDataAttr(pdpElement, 'analytics-scripture-reference-3')) {
      item.scripture_reference_3 = getDataAttr(pdpElement, 'analytics-scripture-reference-3');
    }

    if (getDataAttr(pdpElement, 'analytics-scripture-reference-4')) {
      item.scripture_reference_4 = getDataAttr(pdpElement, 'analytics-scripture-reference-4');
    }

    if (getDataAttr(pdpElement, 'analytics-scripture-reference-5')) {
      item.scripture_reference_5 = getDataAttr(pdpElement, 'analytics-scripture-reference-5');
    }

    if (getDataAttr(pdpElement, 'analytics-scripture-reference-6')) {
      item.scripture_reference_6 = getDataAttr(pdpElement, 'analytics-scripture-reference-6');
    }

    if (scriptureReferenceCount !== null) {
      item.scripture_reference_count = scriptureReferenceCount;
    }

    if (getDataAttr(pdpElement, 'analytics-biblical-theme')) {
      item.biblical_theme = getDataAttr(pdpElement, 'analytics-biblical-theme');
    }

    if (getDataAttr(pdpElement, 'analytics-occasion')) {
      item.occasion = getDataAttr(pdpElement, 'analytics-occasion');
    }

    if (getDataAttr(pdpElement, 'analytics-chain-style')) {
      item.chain_style = getDataAttr(pdpElement, 'analytics-chain-style');
    }

    if (getDataAttr(pdpElement, 'analytics-is-set')) {
      item.is_set = getDataAttr(pdpElement, 'analytics-is-set');
    }

    if (getDataAttr(pdpElement, 'analytics-price-bracket')) {
      item.price_bracket = getDataAttr(pdpElement, 'analytics-price-bracket');
    }

    if (skuCount !== null) {
      item.sku_count = skuCount;
    }

    if (getDataAttr(pdpElement, 'analytics-product-handle')) {
      item.item_handle = getDataAttr(pdpElement, 'analytics-product-handle');
    }

    if (getDataAttr(pdpElement, 'analytics-variant-id')) {
      item.variant_id = getDataAttr(pdpElement, 'analytics-variant-id');
    }

    if (getDataAttr(pdpElement, 'analytics-product-id')) {
      item.product_id = getDataAttr(pdpElement, 'analytics-product-id');
    }

    return item;
  }

  function buildItemFromVariantAddItem(itemData) {
    var item = {};
    var price = safeNumber(itemData && itemData.price);
    var quantity = safeNumber(itemData && itemData.quantity);

    if (!itemData || typeof itemData !== 'object') {
      return null;
    }

    if (itemData.id) {
      item.item_id = String(itemData.id);
      item.variant_id = String(itemData.id);
    }

    if (itemData.product_id) {
      item.product_id = String(itemData.product_id);
    }

    if (itemData.product_title || itemData.title) {
      item.item_name = itemData.product_title || itemData.title;
    }

    if (itemData.vendor) {
      item.item_brand = itemData.vendor;
    }

    if (price !== null) {
      item.price = price / 100;
    }

    if (quantity !== null) {
      item.quantity = quantity;
    }

    if (itemData.product_type) {
      item.product_type = itemData.product_type;
    }

    if (itemData.variant_title) {
      item.item_variant = itemData.variant_title;
    }

    if (itemData.sku) {
      item.sku = itemData.sku;
    }

    if (itemData.handle) {
      item.item_handle = itemData.handle;
    }

    if (itemData.url) {
      item.item_url = itemData.url;
    }

    return item.item_id || item.item_name ? item : null;
  }

  function hasVariantAddItemAnalyticsData(itemData) {
    if (!itemData || typeof itemData !== 'object' || Array.isArray(itemData)) {
      return false;
    }

    return Boolean(
      itemData.id ||
      itemData.product_id ||
      itemData.product_title ||
      itemData.title ||
      itemData.vendor ||
      itemData.price ||
      itemData.quantity ||
      itemData.product_type ||
      itemData.variant_title ||
      itemData.sku ||
      itemData.handle ||
      itemData.url
    );
  }

  function normaliseStringMap(source) {
    var normalised = {};

    if (!source || typeof source !== 'object' || Array.isArray(source)) {
      return normalised;
    }

    Object.keys(source).forEach(function (key) {
      var value = source[key];

      if (value === null || value === undefined || value === '') {
        return;
      }

      normalised[String(key)] = typeof value === 'string' ? value : String(value);
    });

    return normalised;
  }

  function normaliseVariantAddRequest(request) {
    var quantity;

    request = request && typeof request === 'object' ? request : {};
    quantity = safeNumber(request.quantity);

    return {
      variantId: request.variantId ? String(request.variantId) : null,
      quantity: quantity !== null && quantity > 0 ? quantity : 1,
      sellingPlanId: request.sellingPlanId ? String(request.sellingPlanId) : null,
      properties: normaliseStringMap(request.properties)
    };
  }

  function getVariantAddRequestContext(event) {
    var detail = event && event.detail ? event.detail : null;
    var request = normaliseVariantAddRequest(detail && detail.request);
    var formElement = event && event.target && typeof event.target.matches === 'function' && event.target.matches('form') ? event.target : null;
    var formData;
    var hasRequestQuantity = detail && detail.request && detail.request.quantity !== undefined && detail.request.quantity !== null && detail.request.quantity !== '';

    if (formElement && (!request.variantId || !hasRequestQuantity || !request.sellingPlanId || !Object.keys(request.properties).length)) {
      formData = new FormData(formElement);
    }

    if (formData && !request.variantId) {
      request.variantId = formData.get('id');
    }

    if (formData && !hasRequestQuantity) {
      request.quantity = safeNumber(formData.get('quantity')) || 1;
    }

    if (formData && !request.sellingPlanId) {
      request.sellingPlanId = formData.get('selling_plan');
    }

    if (formData && !Object.keys(request.properties).length) {
      formData.forEach(function (value, key) {
        var propertyKeyMatch = key.match(/^properties\[(.+)\]$/);

        if (!propertyKeyMatch || value === '') {
          return;
        }

        request.properties[propertyKeyMatch[1]] = typeof value === 'string' ? value : String(value);
      });
    }

    return request;
  }

  function getCartItemProperties(cartItem) {
    return normaliseStringMap(cartItem && cartItem.properties);
  }

  function getCartItemSellingPlanId(cartItem) {
    if (!cartItem || !cartItem.selling_plan_allocation) {
      return null;
    }

    if (cartItem.selling_plan_allocation.selling_plan && cartItem.selling_plan_allocation.selling_plan.id) {
      return String(cartItem.selling_plan_allocation.selling_plan.id);
    }

    if (cartItem.selling_plan_allocation.selling_plan_id) {
      return String(cartItem.selling_plan_allocation.selling_plan_id);
    }

    return null;
  }

  function cartItemMatchesVariantAddRequest(cartItem, requestContext) {
    var requestProperties;
    var cartProperties;

    if (!cartItem || !requestContext || !requestContext.variantId) {
      return false;
    }

    if (String(cartItem.variant_id || cartItem.id || '') !== requestContext.variantId) {
      return false;
    }

    if (requestContext.sellingPlanId && getCartItemSellingPlanId(cartItem) !== requestContext.sellingPlanId) {
      return false;
    }

    requestProperties = requestContext.properties || {};

    if (!Object.keys(requestProperties).length) {
      return true;
    }

    cartProperties = getCartItemProperties(cartItem);

    return Object.keys(requestProperties).every(function (key) {
      return cartProperties[key] === requestProperties[key];
    });
  }

  function getVariantAddCartItem(detail, requestContext) {
    var candidates;

    if (!detail || !detail.cart || !detail.cart.items || !detail.cart.items.length || !requestContext || !requestContext.variantId) {
      return null;
    }

    candidates = detail.cart.items.filter(function (cartItem) {
      return cartItemMatchesVariantAddRequest(cartItem, requestContext);
    });

    return candidates.length === 1 ? candidates[0] : null;
  }

  function getPdpAnalyticsItemForCartItem(cartItem, requestContext) {
    var pdpElement = getPdpAnalyticsElement();
    var pdpItem = buildItemFromPdpAnalyticsElement(pdpElement);
    var pdpVariantId;
    var pdpProductId;
    var cartVariantId;
    var cartProductId;

    if (!pdpItem) {
      return null;
    }

    pdpVariantId = pdpItem.variant_id ? String(pdpItem.variant_id) : null;
    pdpProductId = pdpItem.product_id ? String(pdpItem.product_id) : null;
    cartVariantId = cartItem && (cartItem.variant_id || cartItem.id) ? String(cartItem.variant_id || cartItem.id) : null;
    cartProductId = cartItem && cartItem.product_id ? String(cartItem.product_id) : null;

    if (requestContext && requestContext.variantId && pdpVariantId && requestContext.variantId === pdpVariantId) {
      return pdpItem;
    }

    if (pdpVariantId && cartVariantId && pdpVariantId === cartVariantId) {
      return pdpItem;
    }

    if (pdpProductId && cartProductId && pdpProductId === cartProductId) {
      return pdpItem;
    }

    return null;
  }

  function buildItemFromCartItem(cartItem, quantityOverride, pdpItem) {
    var item = {};
    var price = safeNumber(cartItem && (cartItem.final_price || cartItem.price));
    var quantity = quantityOverride !== null && quantityOverride !== undefined ? safeNumber(quantityOverride) : safeNumber(cartItem && cartItem.quantity);
    var enrichKeys = [
      'included_jewelry',
      'color_or_design',
      'scripture_reference',
      'scripture_reference_2',
      'scripture_reference_3',
      'scripture_reference_4',
      'scripture_reference_5',
      'scripture_reference_6',
      'scripture_reference_count',
      'biblical_theme',
      'occasion',
      'chain_style',
      'is_set',
      'price_bracket',
      'sku_count'
    ];

    if (!cartItem || typeof cartItem !== 'object' || Array.isArray(cartItem)) {
      return null;
    }

    if (cartItem.variant_id || cartItem.id) {
      item.item_id = String(cartItem.variant_id || cartItem.id);
      item.variant_id = String(cartItem.variant_id || cartItem.id);
    }

    if (cartItem.product_id) {
      item.product_id = String(cartItem.product_id);
    }

    if (cartItem.product_title || cartItem.title) {
      item.item_name = cartItem.product_title || cartItem.title;
    }

    if (cartItem.vendor) {
      item.item_brand = cartItem.vendor;
    }

    if (price !== null) {
      item.price = price / 100;
    }

    if (quantity !== null && quantity > 0) {
      item.quantity = quantity;
    }

    if (cartItem.product_type) {
      item.product_type = cartItem.product_type;
    }

    if (cartItem.variant_title && cartItem.variant_title !== 'Default Title') {
      item.item_variant = cartItem.variant_title;
    }

    if (cartItem.sku) {
      item.sku = cartItem.sku;
    }

    if (cartItem.handle) {
      item.item_handle = cartItem.handle;
    }

    if (cartItem.url) {
      item.item_url = cartItem.url;
    }

    if (pdpItem) {
      if (!item.item_name && pdpItem.item_name) {
        item.item_name = pdpItem.item_name;
      }

      if (!item.item_brand && pdpItem.item_brand) {
        item.item_brand = pdpItem.item_brand;
      }

      if (item.price === undefined && pdpItem.price !== undefined) {
        item.price = pdpItem.price;
      }

      if (!item.product_type && pdpItem.product_type) {
        item.product_type = pdpItem.product_type;
      }

      if (!item.item_handle && pdpItem.item_handle) {
        item.item_handle = pdpItem.item_handle;
      }

      if (!item.product_id && pdpItem.product_id) {
        item.product_id = pdpItem.product_id;
      }

      enrichKeys.forEach(function (key) {
        if (item[key] === undefined && pdpItem[key] !== undefined) {
          item[key] = pdpItem[key];
        }
      });
    }

    return item.item_id || item.item_name ? item : null;
  }

  function computeAddToCartValue(items) {
    var total = 0;

    if (!items || !items.length) {
      return null;
    }

    for (var index = 0; index < items.length; index += 1) {
      var item = items[index];
      var price = safeNumber(item && item.price);
      var quantity = safeNumber(item && item.quantity);

      if (price === null || quantity === null) {
        return null;
      }

      total += price * quantity;
    }

    return Math.round(total * 100) / 100;
  }

  function pushAddToCartEvent(ecommerceItems, options) {
    var ecommerce = {
      items: ecommerceItems
    };
    var currency = options && typeof options.currency === 'string' ? options.currency.trim() : '';
    var value = safeNumber(options && options.value);

    if (!ecommerceItems || !ecommerceItems.length) {
      return false;
    }

    if (currency) {
      ecommerce.currency = currency;
    }

    if (value !== null) {
      ecommerce.value = value;
    }

    TFAnalytics.clearEcommerce();

    return push({
      event: 'add_to_cart',
      ecommerce: ecommerce
    });
  }

  function getCartAnalyticsContextElement(surface) {
    if (!surface) {
      return null;
    }

    return document.querySelector('[data-analytics-cart-context][data-analytics-cart-surface="' + surface + '"]');
  }

  function getCartAnalyticsContext(surface) {
    var contextElement = getCartAnalyticsContextElement(surface);
    var contextPayload;

    if (!contextElement) {
      return null;
    }

    try {
      contextPayload = JSON.parse(contextElement.textContent || '');
    } catch (error) {
      return null;
    }

    if (!contextPayload || typeof contextPayload !== 'object' || Array.isArray(contextPayload)) {
      return null;
    }

    return contextPayload;
  }

  function buildItemFromCartContextItem(itemData) {
    var item = {};
    var allowedKeys = [
      'item_id',
      'product_id',
      'variant_id',
      'item_name',
      'item_brand',
      'product_type',
      'included_jewelry',
      'price',
      'quantity',
      'item_variant',
      'sku',
      'item_handle',
      'item_url',
      'color_or_design',
      'scripture_reference',
      'scripture_reference_2',
      'scripture_reference_3',
      'scripture_reference_4',
      'scripture_reference_5',
      'scripture_reference_6',
      'scripture_reference_count',
      'biblical_theme',
      'occasion',
      'chain_style',
      'is_set',
      'price_bracket',
      'sku_count'
    ];

    if (!itemData || typeof itemData !== 'object' || Array.isArray(itemData)) {
      return null;
    }

    allowedKeys.forEach(function (key) {
      if (itemData[key] !== null && itemData[key] !== undefined && itemData[key] !== '') {
        item[key] = itemData[key];
      }
    });

    return item.item_id || item.item_name ? item : null;
  }

  function getCartAnalyticsContextByPriority(surface) {
    if (surface) {
      return getCartAnalyticsContext(surface) || getCartAnalyticsContext(surface === 'cart_page' ? 'drawer' : 'cart_page');
    }

    return getCartAnalyticsContext('cart_page') || getCartAnalyticsContext('drawer');
  }

  function getCartContextItemByLineKey(lineKey, surface) {
    var cartContext = getCartAnalyticsContextByPriority(surface);

    if (!lineKey || !cartContext || !cartContext.items || !cartContext.items.length) {
      return null;
    }

    return cartContext.items.find(function (item) {
      return item && item.line_key === lineKey;
    }) || null;
  }

  function getCartContextItemForVariantAddRequest(requestContext, surface) {
    var cartContext = getCartAnalyticsContextByPriority(surface);
    var candidates;

    if (!requestContext || !requestContext.variantId || !cartContext || !cartContext.items || !cartContext.items.length) {
      return null;
    }

    candidates = cartContext.items.filter(function (item) {
      return item && String(item.variant_id || item.item_id || '') === requestContext.variantId;
    });

    if (candidates.length !== 1) {
      return null;
    }

    return {
      cartContext: cartContext,
      item: candidates[0]
    };
  }

  function cartContainsLineKey(cart, lineKey) {
    if (!cart || !cart.items || !cart.items.length || !lineKey) {
      return false;
    }

    return cart.items.some(function (item) {
      return item && item.key === lineKey;
    });
  }

  function trackAddToCart(items, options) {
    var ecommerceItems;

    if (!items || !items.length) {
      return false;
    }

    ecommerceItems = items
      .map(buildItemFromVariantAddItem)
      .filter(function (item) {
        return item && (item.item_id || item.item_name);
      });

    if (!ecommerceItems.length) {
      return false;
    }

    return pushAddToCartEvent(ecommerceItems, {
      currency: options && options.currency,
      value: options && options.value !== undefined ? options.value : computeAddToCartValue(ecommerceItems)
    });
  }

  function trackVariantAddEvent(event) {
    var detail = event && event.detail ? event.detail : null;
    var items = detail && detail.items ? detail.items : null;
    var requestContext = getVariantAddRequestContext(event);
    var cartCurrency = detail && detail.cart && detail.cart.currency ? detail.cart.currency : null;
    var cartItem;
    var pdpItem;
    var ecommerceItem;

    if (items && items.length && items.some(hasVariantAddItemAnalyticsData)) {
      return trackAddToCart(items, {
        currency: cartCurrency
      });
    }

    // Live storefront `variant:add` can carry `detail.items[0] = { sections: ... }`, so resolve the actual added line from the confirmed cart instead.
    cartItem = getVariantAddCartItem(detail, requestContext);

    if (!cartItem) {
      return false;
    }

    pdpItem = getPdpAnalyticsItemForCartItem(cartItem, requestContext);
    ecommerceItem = buildItemFromCartItem(cartItem, requestContext.quantity, pdpItem);

    if (!ecommerceItem) {
      return false;
    }

    return pushAddToCartEvent([ecommerceItem], {
      currency: cartCurrency,
      value: computeAddToCartValue([ecommerceItem])
    });
  }

  function trackRemoveFromCart(changeDetail) {
    var targetQuantity = safeNumber(changeDetail && changeDetail.targetQuantity);
    var previousCartItem;
    var previousQuantity;
    var removedQuantity;
    var item;

    if (!changeDetail || typeof changeDetail !== 'object' || targetQuantity !== 0) {
      return false;
    }

    if (cartContainsLineKey(changeDetail.cart, changeDetail.lineKey)) {
      return false;
    }

    previousCartItem = getCartContextItemByLineKey(changeDetail.lineKey, changeDetail.surface);

    if (!previousCartItem) {
      return false;
    }

    previousQuantity = safeNumber(previousCartItem.quantity);

    if (previousQuantity === null || previousQuantity <= 0) {
      return false;
    }

    removedQuantity = previousQuantity - targetQuantity;

    if (removedQuantity <= 0) {
      return false;
    }

    item = buildItemFromCartContextItem(previousCartItem);

    if (!item || (!item.item_id && !item.item_name)) {
      return false;
    }

    item.quantity = removedQuantity;

    TFAnalytics.clearEcommerce();

    return push({
      event: 'remove_from_cart',
      ecommerce: {
        items: [item]
      }
    });
  }

  function trackCartPageViewCart() {
    var pageContext = getPageContext();
    var cartContext;
    var ecommerceItems;
    var ecommerce = {};

    if (pageContext.template !== 'cart') {
      return false;
    }

    cartContext = getCartAnalyticsContext('cart_page');

    if (!cartContext || !cartContext.items || !cartContext.items.length) {
      return false;
    }

    ecommerceItems = cartContext.items
      .map(buildItemFromCartContextItem)
      .filter(function (item) {
        return item && (item.item_id || item.item_name);
      });

    if (!ecommerceItems.length) {
      return false;
    }

    ecommerce.items = ecommerceItems;

    if (cartContext.currency) {
      ecommerce.currency = cartContext.currency;
    }

    if (cartContext.total_value !== null && cartContext.total_value !== undefined && cartContext.total_value !== '') {
      ecommerce.value = cartContext.total_value;
    }

    TFAnalytics.clearEcommerce();

    return push({
      event: 'view_cart',
      ecommerce: ecommerce
    });
  }

  function trackPdpViewItem() {
    var pdpElement = getPdpAnalyticsElement();
    var item;

    if (!pdpElement) {
      return false;
    }

    item = buildItemFromPdpAnalyticsElement(pdpElement);

    if (!item || (!item.item_id && !item.item_name)) {
      return false;
    }

    TFAnalytics.clearEcommerce();

    return push({
      event: 'view_item',
      ecommerce: {
        items: [item]
      }
    });
  }

  function trackCollectionGridViewItemList(options) {
    var trackOptions = options || {};
    var listState = buildCollectionGridListState(trackOptions.url);
    var ecommerce;
    var payload;
    var changeType;

    if (!listState) {
      return false;
    }

    if (TFAnalytics.collectionGridSeenListStateKeys[listState.listStateKey]) {
      return false;
    }

    changeType = getCollectionGridListStateChangeType(listState, TFAnalytics.lastCollectionGridListState, trackOptions.changeType);
    ecommerce = { items: listState.items };

    if (listState.itemListName) {
      ecommerce.item_list_name = listState.itemListName;
    }

    if (listState.itemListId) {
      ecommerce.item_list_id = listState.itemListId;
    }

    TFAnalytics.clearEcommerce();

    payload = {
      event: 'view_item_list',
      ecommerce: ecommerce,
      source_component: listState.sourceComponent,
      collection_handle: listState.collectionHandle,
      collection_type: listState.collectionType,
      sort_option: listState.sortOption,
      page_number: listState.pageNumber,
      results_count: listState.resultsCount,
      rendered_item_count: listState.renderedItemCount,
      applied_filter_count: listState.appliedFilterCount,
      applied_filters: listState.appliedFilters,
      grid_mode: listState.gridMode,
      list_state_key: listState.listStateKey,
      list_state_change_type: changeType
    };

    if (push(payload)) {
      TFAnalytics.collectionGridSeenListStateKeys[listState.listStateKey] = true;
      TFAnalytics.lastCollectionGridListState = listState;
      return true;
    }

    return false;
  }

  function trackHomepageRailViewItemList(railPane) {
    var pageContext = getPageContext();
    var listState;
    var ecommerce;
    var payload;

    if (pageContext.template !== 'index') {
      return false;
    }

    if (!isHomepageRailPaneVisible(railPane)) {
      return false;
    }

    listState = buildHomepageRailListState(railPane);

    if (!listState) {
      return false;
    }

    if (TFAnalytics.homepageRailSeenListStateKeys[listState.listStateKey]) {
      return false;
    }

    ecommerce = { items: listState.items };

    if (listState.itemListName) {
      ecommerce.item_list_name = listState.itemListName;
    }

    if (listState.itemListId) {
      ecommerce.item_list_id = listState.itemListId;
    }

    TFAnalytics.clearEcommerce();

    payload = {
      event: 'view_item_list',
      ecommerce: ecommerce,
      source_component: listState.sourceComponent,
      collection_handle: listState.collectionHandle,
      collection_type: listState.collectionType,
      rendered_item_count: listState.renderedItemCount,
      homepage_section_id: listState.sectionId,
      homepage_block_id: listState.blockId,
      list_state_key: listState.listStateKey,
      list_state_change_type: 'selected_rail_visible'
    };

    if (push(payload)) {
      TFAnalytics.homepageRailSeenListStateKeys[listState.listStateKey] = true;
      return true;
    }

    return false;
  }

  function trackComplementaryProductsViewItemList(complementaryProductsElement) {
    var pageContext = getPageContext();
    var listState;
    var ecommerce;
    var payload;

    if (pageContext.template !== 'product') {
      return false;
    }

    listState = buildComplementaryProductsListState(complementaryProductsElement);

    if (!listState) {
      return false;
    }

    if (TFAnalytics.complementaryProductsSeenListStateKeys[listState.listStateKey]) {
      return false;
    }

    ecommerce = { items: listState.items };

    if (listState.itemListName) {
      ecommerce.item_list_name = listState.itemListName;
    }

    if (listState.itemListId) {
      ecommerce.item_list_id = listState.itemListId;
    }

    TFAnalytics.clearEcommerce();

    payload = {
      event: 'view_item_list',
      ecommerce: ecommerce,
      source_component: listState.sourceComponent,
      rendered_item_count: listState.renderedItemCount,
      complementary_products_section_id: listState.sectionId,
      complementary_products_block_id: listState.blockId,
      list_state_key: listState.listStateKey,
      list_state_change_type: 'async_render_committed'
    };

    if (push(payload)) {
      TFAnalytics.complementaryProductsSeenListStateKeys[listState.listStateKey] = true;
      return true;
    }

    return false;
  }

  function getCollectionGridSelectItemAnchor(target) {
    if (!target || typeof target.closest !== 'function') {
      return null;
    }

    return target.closest('a.product-card__media[href], a.product-title[href]');
  }

  function getCollectionGridSelectItemProductCard(element) {
    if (!element || typeof element.closest !== 'function') {
      return null;
    }

    // Simply find the nearest product-card with the correct analytics source; do not try to match the entire ancestor chain
    return element.closest('product-card.product-card[data-analytics-source-component="collection_grid"]');
  }

  function trackCollectionGridSelectItem(productCard) {
    var item = buildItemFromProductCard(productCard);
    var itemListName = getDataAttr(productCard, 'analytics-item-list-name');
    var itemListId = getDataAttr(productCard, 'analytics-item-list-id');
    var sourceComponent = getSourceComponent(productCard);
    var ecommerce = { items: [item] };

    if (!item || (!item.item_id && !item.item_name)) {
      return false;
    }

    if (itemListName) {
      ecommerce.item_list_name = itemListName;
    }

    if (itemListId) {
      ecommerce.item_list_id = itemListId;
    }

    TFAnalytics.clearEcommerce();

    return push({
      event: 'select_item',
      source_component: sourceComponent,
      ecommerce: ecommerce
    });
  }

  function getHomepageRailSelectItemProductCard(element) {
    if (!element || typeof element.closest !== 'function') {
      return null;
    }

    return element.closest('product-card.product-card[data-analytics-source-component="homepage_featured_collection_rail"]');
  }

  function getComplementaryProductsSelectItemAnchor(target) {
    if (!target || typeof target.closest !== 'function') {
      return null;
    }

    return target.closest('a.product-card__media[href], a.horizontal-product-card__figure[href], a.product-title[href]');
  }

  function getComplementaryProductsSelectItemProductCard(element) {
    if (!element || typeof element.closest !== 'function') {
      return null;
    }

    return element.closest('product-card.product-card[data-analytics-source-component="pdp_complementary_products"], .horizontal-product-card[data-analytics-source-component="pdp_complementary_products"]');
  }

  function trackHomepageRailSelectItem(productCard) {
    var item = buildItemFromProductCard(productCard);
    var itemListName = getDataAttr(productCard, 'analytics-item-list-name');
    var itemListId = getDataAttr(productCard, 'analytics-item-list-id');
    var sourceComponent = getSourceComponent(productCard);
    var ecommerce = { items: [item] };

    if (!item || (!item.item_id && !item.item_name)) {
      return false;
    }

    if (itemListName) {
      ecommerce.item_list_name = itemListName;
    }

    if (itemListId) {
      ecommerce.item_list_id = itemListId;
    }

    TFAnalytics.clearEcommerce();

    return push({
      event: 'select_item',
      source_component: sourceComponent,
      ecommerce: ecommerce
    });
  }

  function trackComplementaryProductsSelectItem(productCard) {
    var item = buildItemFromProductCard(productCard);
    var itemListName = getDataAttr(productCard, 'analytics-item-list-name');
    var itemListId = getDataAttr(productCard, 'analytics-item-list-id');
    var sourceComponent = getSourceComponent(productCard);
    var ecommerce = { items: [item] };

    if (!item || (!item.item_id && !item.item_name)) {
      return false;
    }

    if (itemListName) {
      ecommerce.item_list_name = itemListName;
    }

    if (itemListId) {
      ecommerce.item_list_id = itemListId;
    }

    TFAnalytics.clearEcommerce();

    return push({
      event: 'select_item',
      source_component: sourceComponent,
      ecommerce: ecommerce
    });
  }

  function buildLinkedProductSwatchItem(swatchElement) {
    var itemId = getDataAttr(swatchElement, 'analytics-destination-item-id');
    var itemName = getDataAttr(swatchElement, 'analytics-destination-item-name');
    var itemHandle = getDataAttr(swatchElement, 'analytics-destination-item-handle');
    var itemUrl = getDataAttr(swatchElement, 'analytics-destination-item-url');
    var item = {};

    if (!itemId && !itemName) {
      return null;
    }

    if (itemId) {
      item.item_id = itemId;
    }

    if (itemName) {
      item.item_name = itemName;
    }

    if (itemHandle) {
      item.item_handle = itemHandle;
    }

    if (itemUrl) {
      item.item_url = itemUrl;
    }

    return item;
  }

  function buildLinkedProductSwatchContext(swatchElement) {
    var swatchWrapper = swatchElement && typeof swatchElement.closest === 'function'
      ? swatchElement.closest('[data-tf-color-selector]')
      : null;
    var item = buildLinkedProductSwatchItem(swatchElement);

    if (!swatchWrapper || !item) {
      return null;
    }

    return {
      item: item,
      originItemId: getDataAttr(swatchWrapper, 'analytics-origin-item-id'),
      originItemName: getDataAttr(swatchWrapper, 'analytics-origin-item-name'),
      originItemHandle: getDataAttr(swatchWrapper, 'analytics-origin-item-handle'),
      swatchName: getDataAttr(swatchElement, 'analytics-swatch-name'),
      swatchHex: getDataAttr(swatchElement, 'analytics-swatch-hex')
    };
  }

  function isLinkedProductSwatchSelected(swatchElement) {
    return getDataAttr(swatchElement, 'analytics-swatch-selected') === 'true';
  }

  function getCollectionGridLinkedProductSwatch(target) {
    if (!target || typeof target.closest !== 'function') {
      return null;
    }

    return target.closest('.tf-color-selector--card button.tf-swatch[data-tf-swatch-url]');
  }

  function trackCollectionGridLinkedProductSwatch(productCard, swatchElement) {
    var swatchContext = buildLinkedProductSwatchContext(swatchElement);
    var itemListName = getDataAttr(productCard, 'analytics-item-list-name');
    var itemListId = getDataAttr(productCard, 'analytics-item-list-id');
    var index = safeNumber(getDataAttr(productCard, 'analytics-index'));
    var payload;

    if (!swatchContext) {
      return false;
    }

    payload = {
      event: 'select_linked_swatch',
      source_component: 'collection_grid',
      navigation_context: 'list_to_linked_product',
      ecommerce: {
        items: [swatchContext.item]
      },
      linked_from_item_id: getDataAttr(productCard, 'analytics-product-id') || swatchContext.originItemId,
      linked_from_item_name: getDataAttr(productCard, 'analytics-product-title') || swatchContext.originItemName,
      linked_from_item_handle: getDataAttr(productCard, 'analytics-product-handle') || swatchContext.originItemHandle,
      swatch_name: swatchContext.swatchName,
      swatch_hex_code: swatchContext.swatchHex,
      collection_handle: getDataAttr(productCard, 'analytics-collection-handle'),
      collection_type: getDataAttr(productCard, 'analytics-collection-type')
    };

    if (itemListName) {
      payload.ecommerce.item_list_name = itemListName;
    }

    if (itemListId) {
      payload.ecommerce.item_list_id = itemListId;
    }

    if (index !== null) {
      payload.index = index;
    }

    TFAnalytics.clearEcommerce();

    return push(payload);
  }

  function getPdpLinkedProductSwatch(target) {
    var swatch;

    if (!target || typeof target.closest !== 'function') {
      return null;
    }

    swatch = target.closest('.shopify-section--main-product [data-tf-color-selector] a.tf-swatch[href]');

    if (!swatch) {
      return null;
    }

    if (swatch.closest('product-recommendations[data-analytics-complementary-products="true"]')) {
      return null;
    }

    return swatch;
  }

  function trackPdpLinkedProductSwatch(swatchElement) {
    var swatchContext = buildLinkedProductSwatchContext(swatchElement);

    if (!swatchContext) {
      return false;
    }

    TFAnalytics.clearEcommerce();

    return push({
      event: 'select_linked_swatch',
      source_component: 'pdp_color_selector',
      navigation_context: 'pdp_to_linked_product',
      ecommerce: {
        items: [swatchContext.item]
      },
      linked_from_item_id: swatchContext.originItemId,
      linked_from_item_name: swatchContext.originItemName,
      linked_from_item_handle: swatchContext.originItemHandle,
      swatch_name: swatchContext.swatchName,
      swatch_hex_code: swatchContext.swatchHex
    });
  }

  function handleCollectionGridSelectItemClick(event) {
    var anchor = getCollectionGridSelectItemAnchor(event.target);
    var productCard;

    if (!anchor || event.tfAnalyticsCollectionGridSelectItemTracked) {
      return;
    }

    productCard = getCollectionGridSelectItemProductCard(anchor);

    if (!productCard) {
      return;
    }

    event.tfAnalyticsCollectionGridSelectItemTracked = true;
    trackCollectionGridSelectItem(productCard);
  }

  function handleHomepageRailSelectItemClick(event) {
    var pageContext = getPageContext();
    var anchor = getCollectionGridSelectItemAnchor(event.target);
    var productCard;

    if (pageContext.template !== 'index' || !anchor || event.tfAnalyticsHomepageRailSelectItemTracked) {
      return;
    }

    productCard = getHomepageRailSelectItemProductCard(anchor);

    if (!productCard) {
      return;
    }

    event.tfAnalyticsHomepageRailSelectItemTracked = true;
    trackHomepageRailSelectItem(productCard);
  }

  function handleComplementaryProductsSelectItemClick(event) {
    var pageContext = getPageContext();
    var anchor = getComplementaryProductsSelectItemAnchor(event.target);
    var productCard;

    if (pageContext.template !== 'product' || !anchor || event.tfAnalyticsComplementaryProductsSelectItemTracked) {
      return;
    }

    productCard = getComplementaryProductsSelectItemProductCard(anchor);

    if (!productCard) {
      return;
    }

    event.tfAnalyticsComplementaryProductsSelectItemTracked = true;
    trackComplementaryProductsSelectItem(productCard);
  }

  function handleLinkedProductSwatchClick(event) {
    var collectionSwatch = getCollectionGridLinkedProductSwatch(event.target);
    var pdpSwatch;
    var productCard;

    if (event.tfAnalyticsLinkedProductSwatchTracked) {
      return;
    }

    if (collectionSwatch) {
      productCard = getCollectionGridSelectItemProductCard(collectionSwatch);

      if (!productCard) {
        return;
      }

      if (isLinkedProductSwatchSelected(collectionSwatch)) {
        return;
      }

      event.tfAnalyticsLinkedProductSwatchTracked = true;
      trackCollectionGridLinkedProductSwatch(productCard, collectionSwatch);
      return;
    }

    pdpSwatch = getPdpLinkedProductSwatch(event.target);

    if (!pdpSwatch) {
      return;
    }

    if (isLinkedProductSwatchSelected(pdpSwatch)) {
      return;
    }

    productCard = pdpSwatch.closest('product-card.product-card[data-analytics-source-component="collection_grid"]');

    if (productCard) {
      return;
    }

    event.tfAnalyticsLinkedProductSwatchTracked = true;
    trackPdpLinkedProductSwatch(pdpSwatch);
  }

  function handleVariantAdded(event) {
    trackVariantAddEvent(event);
  }

  function consumePendingAddToCart() {
    var pageContext = getPageContext();
    var pendingPayload;
    var requestContext;
    var cartContextMatch;
    var item;

    if (pageContext.template !== 'cart') {
      return false;
    }

    try {
      pendingPayload = sessionStorage.getItem(PENDING_ADD_TO_CART_STORAGE_KEY);

      if (!pendingPayload) {
        return false;
      }

      sessionStorage.removeItem(PENDING_ADD_TO_CART_STORAGE_KEY);
      pendingPayload = JSON.parse(pendingPayload);
    } catch (error) {
      try {
        sessionStorage.removeItem(PENDING_ADD_TO_CART_STORAGE_KEY);
      } catch (removeError) {
      }

      return false;
    }

    if (!pendingPayload || !pendingPayload.items || !pendingPayload.items.length) {
      return false;
    }

    if (trackAddToCart(pendingPayload.items)) {
      return true;
    }

    requestContext = normaliseVariantAddRequest(pendingPayload.request);
    cartContextMatch = getCartContextItemForVariantAddRequest(requestContext, 'cart_page');

    if (!cartContextMatch) {
      return false;
    }

    item = buildItemFromCartContextItem(cartContextMatch.item);

    if (!item) {
      return false;
    }

    item.quantity = requestContext.quantity;

    return pushAddToCartEvent([item], {
      currency: cartContextMatch.cartContext.currency,
      value: computeAddToCartValue([item])
    });
  }

  function handleCartLineChangeSuccess(event) {
    trackRemoveFromCart(event && event.detail ? event.detail : null);
  }

  function handleCollectionResultsReplaced(event) {
    var eventDetail = event && event.detail ? event.detail : {};

    trackCollectionGridViewItemList({
      url: eventDetail.url,
      changeType: 'results_replaced_unknown'
    });
  }

  function handleHomepageRailCarouselSettle(event) {
    var carouselElement = event && event.target;
    var railPane;

    if (!carouselElement || carouselElement.tagName !== 'FEATURED-COLLECTIONS-CAROUSEL' || !carouselElement.hasAttribute('data-analytics-homepage-rails')) {
      return;
    }

    railPane = getHomepageRailSelectedPane(carouselElement);

    if (!railPane) {
      return;
    }

    trackHomepageRailViewItemList(railPane);
  }

  function initCollectionGridViewItemList() {
    runOnce('collection-grid-view-item-list', function () {
      trackCollectionGridViewItemList({ changeType: 'initial_load' });
      document.documentElement.addEventListener(COLLECTION_RESULTS_REPLACED_EVENT, handleCollectionResultsReplaced);
    });
  }

  function initHomepageRailViewItemList() {
    runOnce('homepage-rail-view-item-list', function () {
      var carousels = getHomepageRailCarousels();
      var observer;

      if (!carousels.length) {
        return;
      }

      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var railPane;

          if (!entry.isIntersecting) {
            return;
          }

          railPane = getHomepageRailSelectedPane(entry.target);

          if (!railPane) {
            return;
          }

          trackHomepageRailViewItemList(railPane);
        });
      }, { threshold: 0.5 });

      carousels.forEach(function (carouselElement) {
        observer.observe(carouselElement);
        trackHomepageRailViewItemList(getHomepageRailSelectedPane(carouselElement));
        carouselElement.addEventListener('carousel:settle', handleHomepageRailCarouselSettle);
      });

      TFAnalytics.homepageRailObserver = observer;
    });
  }

  function initComplementaryProductsViewItemList() {
    runOnce('complementary-products-view-item-list', function () {
      var scanQueued = false;
      var observer;
      var observerTarget = getComplementaryProductsObserverTarget();

      function scanComplementaryProducts() {
        scanQueued = false;
        getComplementaryProductsElements().forEach(trackComplementaryProductsViewItemList);
      }

      if (!observerTarget) {
        return;
      }

      observer = new MutationObserver(function () {
        if (scanQueued) {
          return;
        }

        scanQueued = true;
        window.requestAnimationFrame(scanComplementaryProducts);
      });

      observer.observe(observerTarget, { childList: true, subtree: true });
      scanComplementaryProducts();
      TFAnalytics.complementaryProductsObserver = observer;
    });
  }

  function initPdpViewItem() {
    runOnce('pdp-view-item', trackPdpViewItem);
  }

  function initCollectionGridSelectItem() {
    runOnce('collection-grid-select-item', function () {
      document.addEventListener('click', handleCollectionGridSelectItemClick);
    });
  }

  function initHomepageRailSelectItem() {
    runOnce('homepage-rail-select-item', function () {
      document.addEventListener('click', handleHomepageRailSelectItemClick);
    });
  }

  function initComplementaryProductsSelectItem() {
    runOnce('complementary-products-select-item', function () {
      document.addEventListener('click', handleComplementaryProductsSelectItemClick);
    });
  }

  function initLinkedProductSwatchTracking() {
    runOnce('linked-product-swatch-tracking', function () {
      document.addEventListener('click', handleLinkedProductSwatchClick);
    });
  }

  function initAddToCartTracking() {
    runOnce('add-to-cart-tracking', function () {
      document.addEventListener('variant:add', handleVariantAdded);
      consumePendingAddToCart();
    });
  }

  function initCartPageViewCart() {
    runOnce('cart-page-view-cart', trackCartPageViewCart);
  }

  function initRemoveFromCartTracking() {
    runOnce('remove-from-cart-tracking', function () {
      document.documentElement.addEventListener(CART_LINE_CHANGE_SUCCESS_EVENT, handleCartLineChangeSuccess);
    });
  }

  var TFAnalytics = {
    initialised: true,
    version: '0.1.0',
    debug: false,
    guards: {},
    setDebug: setDebug,
    log: log,
    safeNumber: safeNumber,
    getDataAttr: getDataAttr,
    push: push,
    clearEcommerce: clearEcommerce,
    runOnce: runOnce,
    resetGuard: resetGuard,
    getPageContext: getPageContext,
    getCustomerIdentityContextElement: getCustomerIdentityContextElement,
    getCustomerIdentityContext: getCustomerIdentityContext,
    buildItemFromProductCard: buildItemFromProductCard,
    getCollectionGridProductCards: getCollectionGridProductCards,
    getPdpAnalyticsElement: getPdpAnalyticsElement,
    buildItemFromPdpAnalyticsElement: buildItemFromPdpAnalyticsElement,
    buildItemFromVariantAddItem: buildItemFromVariantAddItem,
    getCartAnalyticsContextElement: getCartAnalyticsContextElement,
    getCartAnalyticsContext: getCartAnalyticsContext,
    buildItemFromCartContextItem: buildItemFromCartContextItem,
    getCartAnalyticsContextByPriority: getCartAnalyticsContextByPriority,
    getCartContextItemByLineKey: getCartContextItemByLineKey,
    cartContainsLineKey: cartContainsLineKey,
    trackPdpViewItem: trackPdpViewItem,
    trackAddToCart: trackAddToCart,
    trackRemoveFromCart: trackRemoveFromCart,
    trackCartPageViewCart: trackCartPageViewCart,
    trackCollectionGridViewItemList: trackCollectionGridViewItemList,
    getHomepageRailCarousels: getHomepageRailCarousels,
    getHomepageRailSelectedPane: getHomepageRailSelectedPane,
    getHomepageRailProductCards: getHomepageRailProductCards,
    getComplementaryProductsElements: getComplementaryProductsElements,
    getComplementaryProductsObserverTarget: getComplementaryProductsObserverTarget,
    getComplementaryProductsProductCards: getComplementaryProductsProductCards,
    isHomepageRailPaneVisible: isHomepageRailPaneVisible,
    buildHomepageRailListState: buildHomepageRailListState,
    buildComplementaryProductsListState: buildComplementaryProductsListState,
    trackHomepageRailViewItemList: trackHomepageRailViewItemList,
    trackComplementaryProductsViewItemList: trackComplementaryProductsViewItemList,
    getCollectionGridSelectItemAnchor: getCollectionGridSelectItemAnchor,
    getCollectionGridSelectItemProductCard: getCollectionGridSelectItemProductCard,
    trackCollectionGridSelectItem: trackCollectionGridSelectItem,
    getHomepageRailSelectItemProductCard: getHomepageRailSelectItemProductCard,
    getComplementaryProductsSelectItemAnchor: getComplementaryProductsSelectItemAnchor,
    getComplementaryProductsSelectItemProductCard: getComplementaryProductsSelectItemProductCard,
    trackHomepageRailSelectItem: trackHomepageRailSelectItem,
    trackComplementaryProductsSelectItem: trackComplementaryProductsSelectItem,
    handleCollectionGridSelectItemClick: handleCollectionGridSelectItemClick,
    handleHomepageRailSelectItemClick: handleHomepageRailSelectItemClick,
    handleComplementaryProductsSelectItemClick: handleComplementaryProductsSelectItemClick,
    initCollectionGridViewItemList: initCollectionGridViewItemList,
    initHomepageRailViewItemList: initHomepageRailViewItemList,
    initComplementaryProductsViewItemList: initComplementaryProductsViewItemList,
    initPdpViewItem: initPdpViewItem,
    initCollectionGridSelectItem: initCollectionGridSelectItem,
    initHomepageRailSelectItem: initHomepageRailSelectItem,
    initComplementaryProductsSelectItem: initComplementaryProductsSelectItem,
    buildLinkedProductSwatchItem: buildLinkedProductSwatchItem,
    buildLinkedProductSwatchContext: buildLinkedProductSwatchContext,
    isLinkedProductSwatchSelected: isLinkedProductSwatchSelected,
    getCollectionGridLinkedProductSwatch: getCollectionGridLinkedProductSwatch,
    trackCollectionGridLinkedProductSwatch: trackCollectionGridLinkedProductSwatch,
    getPdpLinkedProductSwatch: getPdpLinkedProductSwatch,
    trackPdpLinkedProductSwatch: trackPdpLinkedProductSwatch,
    handleLinkedProductSwatchClick: handleLinkedProductSwatchClick,
    initLinkedProductSwatchTracking: initLinkedProductSwatchTracking,
    handleVariantAdded: handleVariantAdded,
    consumePendingAddToCart: consumePendingAddToCart,
    initAddToCartTracking: initAddToCartTracking,
    handleCartLineChangeSuccess: handleCartLineChangeSuccess,
    initCartPageViewCart: initCartPageViewCart,
    initRemoveFromCartTracking: initRemoveFromCartTracking,
    getMarketingSignupSurface: getMarketingSignupSurface,
    getMarketingSignupConsentState: getMarketingSignupConsentState,
    refreshMarketingSignupConsentState: refreshMarketingSignupConsentState,
    initMarketingSignupConsent: initMarketingSignupConsent,
    trackMarketingSignupProviderSuccess: trackMarketingSignupProviderSuccess,
    initMarketingSignupProviderSuccess: initMarketingSignupProviderSuccess,
    getCollectionGridElement: getCollectionGridElement,
    getNormalizedCollectionListParams: getNormalizedCollectionListParams,
    buildCollectionGridListState: buildCollectionGridListState,
    getCollectionGridListStateChangeType: getCollectionGridListStateChangeType,
    handleCollectionResultsReplaced: handleCollectionResultsReplaced,
    handleHomepageRailCarouselSettle: handleHomepageRailCarouselSettle,
    collectionGridSeenListStateKeys: {},
    lastCollectionGridListState: null,
    homepageRailSeenListStateKeys: {},
    homepageRailObserver: null,
    complementaryProductsSeenListStateKeys: {},
    complementaryProductsObserver: null,
    marketingSignupSeenForms: {},
    marketingSignupConsentState: 'consent_api_unavailable',
    customerIdentityContext: getCustomerIdentityContext()
  };

  window.TFAnalytics = TFAnalytics;

  try {
    var searchParams = new URLSearchParams(window.location.search);

    if (searchParams.get(DEBUG_QUERY_PARAM) === '1') {
      TFAnalytics.setDebug(true);
      TFAnalytics.log('Debug mode enabled via query string.');
    }
  } catch (error) {
    TFAnalytics.log('Unable to read debug query string.', error);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPdpViewItem();
      initCollectionGridViewItemList();
      initHomepageRailViewItemList();
      initComplementaryProductsViewItemList();
      initCollectionGridSelectItem();
      initHomepageRailSelectItem();
      initComplementaryProductsSelectItem();
      initLinkedProductSwatchTracking();
      initAddToCartTracking();
      initCartPageViewCart();
      initRemoveFromCartTracking();
      initMarketingSignupProviderSuccess();
    });
  } else {
    initPdpViewItem();
    initCollectionGridViewItemList();
    initHomepageRailViewItemList();
    initComplementaryProductsViewItemList();
    initCollectionGridSelectItem();
    initHomepageRailSelectItem();
    initComplementaryProductsSelectItem();
    initLinkedProductSwatchTracking();
    initAddToCartTracking();
    initCartPageViewCart();
    initRemoveFromCartTracking();
    initMarketingSignupProviderSuccess();
  }
})();
